import { FC, useMemo } from 'react';

import { Formik } from 'formik';
import { type FormikHelpers } from 'formik';
import useModal from 'ui/partials/Modal/useModal';
import { DEAL_FORM, DEAL_SCHEMA } from 'modules/account/contact/forms/schema';

import { useGetDeals, useUpdateDeal } from '../hooks';
import AssignDealForm from '../forms/AssignDealForm';

interface PAYLOAD {
  leadId?: string;
  companyId?: string;
}
interface PROPS {
  payload: PAYLOAD;
  source: 'companies' | 'leads';
}

const UpdateContactDealModal: FC<PROPS> = ({ payload, source }) => {
  const { hideModal } = useModal();

  const { mutate: updateDeal } = useUpdateDeal(
    Object.values(payload)[0],
    source,
  );
  const { data: deals } = useGetDeals(payload);

  const onSubmit = (
    values: DEAL_FORM,
    { setSubmitting, resetForm }: FormikHelpers<DEAL_FORM>,
  ) => {
    updateDeal(values as { dealId: string[] }, {
      onSuccess: () => {
        hideModal();
        resetForm();
      },
      onSettled: () => {
        setSubmitting(false);
      },
    });
  };

  const initialValues = useMemo(
    () => ({ dealId: deals?.data?.map(({ _id }: any) => _id) ?? [] }),
    [deals],
  );

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={onSubmit as any}
      validationSchema={DEAL_SCHEMA}
    >
      {() => <AssignDealForm />}
    </Formik>
  );
};

export default UpdateContactDealModal;
